export default __webpack_public_path__ + "static/media/BCBackground.0552a69d.svg";